<template>
  <span
    v-if="product === 'PMS'"
    class="product-tag-bar-warning uppercase px-3 text-xs py-1"
  >
    <span class="font-semibold">PMS</span>
    {{ formatNumber(qty, "0") }}
    <span v-if="qty !== ''">{{ product == "LPG" ? "Kgs" : "Ltrs" }}</span>
  </span>
  <span
    v-else-if="product === 'AGO'"
    class="product-tag-bar-success uppercase px-3 text-xs py-1"
  >
    <span class="font-semibold">AGO</span>
    {{ formatNumber(qty, "0") }}
    <span v-if="qty !== ''">{{ product == "LPG" ? "Kgs" : "Ltrs" }}</span>
  </span>
  <span
    v-else-if="product === 'DPK'"
    class="product-tag-bar-info uppercase px-3 text-xs py-1"
  >
    <span class="font-semibold">DPK</span>
    {{ formatNumber(qty, "0") }}
    <span v-if="qty !== ''">{{ product == "LPG" ? "Kgs" : "Ltrs" }}</span>
  </span>

  <span
    v-else-if="product === 'ATK'"
    class="product-tag-bar-atk uppercase px-3 text-xs py-1"
  >
    <span class="font-semibold">ATK</span>
    {{ formatNumber(qty, "0") }}
    <span v-if="qty !== ''">{{ product == "LPG" ? "Kgs" : "Ltrs" }}</span>
  </span>
  <span v-else class="product-tag-bar-else uppercase px-3 text-xs py-1">
    <span class="font-semibold">{{ product }}</span>
    {{ formatNumber(qty, "0") }}
    <span v-if="qty !== ''">{{ product == "LPG" ? "Kgs" : "Ltrs" }}</span>
  </span>
</template>

<script>
import FlexWrapper from "@/components/UI/Wrappers/FlexWrapper.vue";
import { formatDate, formatNumber, amountFormat } from "@/utils/formatter";
export default {
  name: "productStatusTypeTags",
  props: ["product", "qty"],
  components: { FlexWrapper },
  data() {
    return {
      formatNumber: formatNumber,
    };
  },
  mounted() {
    // console.log(this.products);
  },
};
</script>

<style>
.product-tag-bar-warning {
  border-radius: 10px;
  margin-right: 0.5rem;
  border: 1px solid #e99200;
  padding: 6px 10px;
  /* background: #fff6e6; */
  color: #e49204;
}

.product-tag-bar-info {
  border-radius: 10px;
  margin-right: 0.5rem;
  border: 1px solid #1c8ff9;
  padding: 6px 10px;
  /* background: #1c8ff920; */
  color: #1c8ff9;
}

.product-tag-bar-success {
  border-radius: 10px;
  margin-right: 0.5rem;
  border: 1px solid #00903a;
  padding: 6px 10px;
  /* background: F5FFF9#fff6e6; */
  color: #00903a;
}

.product-tag-bar-atk {
  border-radius: 10px;
  margin-right: 0.5rem;
  border: 1px solid #ff8080;
  padding: 6px 10px;
  /* background: F5FFF9#FFE0E0; */
  color: #ff8080;
}

.product-tag-bar-else {
  border-radius: 10px;
  margin-right: 0.5rem;
  border: 1px solid #000;
  padding: 6px 10px;
  /* background: F5FFF9#E6E6E6; */
  color: #000;
}
</style>
